import styles from './HeaderCellContent.module.scss';

import { Box } from '@mui/material';
import { flexRender, Header } from '@tanstack/react-table';
import clsx from 'clsx';

import { Truncation } from '../../../../../../components/tooltip/Tooltip';
import { TableHeading } from '../../../../../../typography/table-heading/TableHeading';
import { ColumnAdditionalData } from '../../../../types';
import { getAlignment } from '../../../../utils/alignment';
import { SorterV8 } from '../sorter/SorterV8';

interface HeaderCellContentV8Props extends Truncation {
  col: Header<ColumnAdditionalData, unknown>;
  classes?: {
    headerCellHeading?: string;
  };
  onTruncation?: (isTruncated: boolean) => void;
}

export function HeaderCellContentV8(props: HeaderCellContentV8Props) {
  const { col: header, onTruncation } = props;

  const alignment = getAlignment(
    header.column.columnDef.alignment,
    header.column.columnDef.dataType
  );

  const filter =
    header.column.getCanFilter() &&
    !header.column.getIsResizing() &&
    header.column.columnDef.Filter &&
    flexRender(header.column.columnDef.Filter, header.getContext());

  return (
    <div className={clsx(styles.content, header.column.columnDef.headerClass)}>
      <TableHeading
        className={clsx(styles[alignment], props.classes?.headerCellHeading)}
        component="span"
      >
        {alignment === 'right' ? filter : null}
        <SorterV8 column={header} onTruncation={onTruncation}>
          {flexRender(header.column.columnDef.header, header.getContext())}
          {header.column.columnDef.required === true && (
            <Box
              component="span"
              sx={(theme) => ({ color: theme.vars.palette.error.main })}
            >
              *
            </Box>
          )}
        </SorterV8>
        {alignment !== 'right' ? filter : null}
      </TableHeading>
    </div>
  );
}
